import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { suffix, prefix, isNullish, isEqual, isNotNullish, isJSType, isDate, replaceTags, wrapToArray } from '@noda-lib/utils/handlers';
import * as i1 from '@angular/platform-browser';
let AffixPipe = /*#__PURE__*/(() => {
  class AffixPipe {
    transform(value, tag, placement = 'end') {
      const transformer = placement === 'end' ? suffix : prefix;
      return transformer(`${value}`, `${tag}`);
    }
    static {
      this.ɵfac = function AffixPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AffixPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "affix",
        type: AffixPipe,
        pure: true
      });
    }
  }
  return AffixPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConditionPipe = /*#__PURE__*/(() => {
  class ConditionPipe {
    transform(condition, ifValue, elseValue) {
      return Boolean(condition) ? ifValue : elseValue;
    }
    static {
      this.ɵfac = function ConditionPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConditionPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "condition",
        type: ConditionPipe,
        pure: true
      });
    }
  }
  return ConditionPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CURRENCY_SYMBOL_MAP = {
  AED: 'د.إ.',
  AFN: '؋',
  ALL: 'Lek',
  AMD: 'դր.',
  ANG: 'NAf.',
  AOA: 'Kz',
  ARS: '$AR',
  AUD: 'A$',
  AWG: 'Afl.',
  AZN: 'ман.',
  BAM: 'KM',
  BBD: 'Bds$',
  BDT: '৳',
  BGN: 'лв.',
  BHD: 'د.ب.',
  BIF: 'FBu',
  BMD: '$BM',
  BND: '$BN',
  BOB: 'Bs',
  BRL: 'R$',
  BSD: 'BS$',
  BTN: 'BTN',
  BWP: 'P',
  BYN: 'Br',
  BZD: '$BZ',
  CAD: 'CA$',
  CDF: 'FC',
  CHF: 'CHF',
  CLP: '$CL',
  CNY: 'CN¥',
  COP: '$CO',
  CRC: '₡',
  CUC: 'CUC',
  CUP: '$',
  CVE: '',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr.',
  DOP: 'RD$',
  DZD: 'د.ج.',
  EGP: 'ج.م.',
  ERN: 'Nfk',
  ETB: 'ብር',
  EUR: '€',
  FJD: '$FJ',
  FKP: '£FK',
  GBP: '£',
  GEL: 'GEL',
  GHS: 'GH₵',
  GIP: '£GI',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: 'HK$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  IQD: 'د.ع.',
  IRR: 'ر.إ.',
  ISK: 'Ikr',
  JMD: 'JM$',
  JOD: 'د.أ.',
  JPY: '¥',
  KES: 'Ksh',
  KGS: 'сом',
  KHR: '៛',
  KMF: 'CF',
  KPW: 'KPW',
  KRW: '₩',
  KWD: 'د.ك.',
  KYD: '$',
  KZT: '₸',
  LAK: 'LAK',
  LBP: '£LB',
  LKR: 'Rs.',
  LRD: '$',
  LSL: 'LSL',
  LYD: 'د.ل.',
  MAD: 'د.م.',
  MDL: 'L',
  MGA: 'Ar',
  MKD: 'MKD',
  MMK: 'K',
  MNT: 'MNT',
  MOP: 'MOP$',
  MRU: 'أ.م.',
  MUR: 'Rs',
  MVR: 'MVR',
  MWK: 'MK',
  MXN: 'MX$',
  MYR: 'RM',
  MZN: 'MTn',
  NAD: '$NA',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'Nkr',
  NPR: 'नेरू',
  NZD: 'NZ$',
  OMR: 'ر.ع.',
  PAB: 'B/.',
  PEN: 'S/',
  PGK: 'K',
  PHP: '₱',
  PKR: 'Rs',
  PLN: 'zł',
  PYG: 'Gs.',
  QAR: 'ر.ق.',
  RON: 'lei',
  RSD: 'дин.',
  RUB: '₽',
  RWF: 'RF',
  SAR: 'ر.س.',
  SBD: '$SB',
  SCR: 'SR',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: '$SG',
  SHP: '£',
  SLL: 'SLL',
  SOS: 'S',
  SRD: '$SR',
  SSP: '£',
  STN: 'Db',
  SVC: 'SVC',
  SYP: 'ل.س.',
  SZL: 'E',
  THB: '฿',
  TJS: 'TJS',
  TMT: 'ТМТ',
  TND: 'د.ت.',
  TOP: 'T$',
  TRY: '₺',
  TTD: '$TT',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: 'грн.',
  UGX: 'USh',
  USD: '$',
  UYU: '$UY',
  UZS: 'UZS',
  VES: 'Bs.S',
  VND: '₫',
  VUV: 'VT',
  WST: '$WS',
  XAF: 'FCFA',
  XCD: 'EC$',
  XDR: 'XDR',
  XOF: 'F CFA',
  XPF: 'CFPF',
  XSU: 'XSU',
  YER: 'ر.ي.',
  YTL: '₺',
  ZAR: 'R',
  ZMW: 'K',
  ZWL: 'ZWL'
};
let CurrencySymbolPipe = /*#__PURE__*/(() => {
  class CurrencySymbolPipe {
    transform(value) {
      return CURRENCY_SYMBOL_MAP[value.toUpperCase()] || value.toLocaleLowerCase();
    }
    static {
      this.ɵfac = function CurrencySymbolPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CurrencySymbolPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "currencySymbol",
        type: CurrencySymbolPipe,
        pure: true
      });
    }
  }
  return CurrencySymbolPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DefaultValuePipe = /*#__PURE__*/(() => {
  class DefaultValuePipe {
    transform(value, defaultValue) {
      const isShowDefaultValue = isNullish(value) || isEqual(value, '');
      return isShowDefaultValue ? defaultValue : value;
    }
    static {
      this.ɵfac = function DefaultValuePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DefaultValuePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "defaultValue",
        type: DefaultValuePipe,
        pure: true
      });
    }
  }
  return DefaultValuePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DefinedPipe = /*#__PURE__*/(() => {
  class DefinedPipe {
    transform(value) {
      return isNotNullish(value);
    }
    static {
      this.ɵfac = function DefinedPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DefinedPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "defined",
        type: DefinedPipe,
        pure: true
      });
    }
  }
  return DefinedPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EndsWithPipe = /*#__PURE__*/(() => {
  class EndsWithPipe {
    transform(value, suffix) {
      if (isJSType(value, 'string')) {
        return value.endsWith(suffix);
      }
      return false;
    }
    static {
      this.ɵfac = function EndsWithPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EndsWithPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "endsWith",
        type: EndsWithPipe,
        pure: true
      });
    }
  }
  return EndsWithPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EqualPipe = /*#__PURE__*/(() => {
  class EqualPipe {
    transform(predicate, value) {
      return predicate === value;
    }
    static {
      this.ɵfac = function EqualPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EqualPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "equal",
        type: EqualPipe,
        pure: true
      });
    }
  }
  return EqualPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ExcludePropertiesPipe = /*#__PURE__*/(() => {
  class ExcludePropertiesPipe {
    transform(object, props) {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      if (!object || !props?.length) return {};
      return Object.entries(object).reduce((accum, [key, value]) => {
        const isExclude = props.includes(key);
        if (!isExclude) {
          accum[key] = value;
        }
        return accum;
        // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter, @typescript-eslint/consistent-type-assertions
      }, {});
    }
    static {
      this.ɵfac = function ExcludePropertiesPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ExcludePropertiesPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "excludeProps",
        type: ExcludePropertiesPipe,
        pure: true
      });
    }
  }
  return ExcludePropertiesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ExistPipe = /*#__PURE__*/(() => {
  class ExistPipe {
    transform(value, array = []) {
      return array.includes(value);
    }
    static {
      this.ɵfac = function ExistPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ExistPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "exist",
        type: ExistPipe,
        pure: true
      });
    }
  }
  return ExistPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FilterPipe = /*#__PURE__*/(() => {
  class FilterPipe {
    transform(array, field, findStr) {
      if (isNullish(findStr)) return array;else {
        return array.filter(item => {
          const itemValue = String(item[field]).toLocaleLowerCase();
          const stringValue = String(findStr).toLocaleLowerCase();
          return itemValue.includes(stringValue);
        });
      }
    }
    static {
      this.ɵfac = function FilterPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FilterPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "filter",
        type: FilterPipe,
        pure: true
      });
    }
  }
  return FilterPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IncludesPipe = /*#__PURE__*/(() => {
  class IncludesPipe {
    transform(items, item) {
      return items.includes(item);
    }
    static {
      this.ɵfac = function IncludesPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IncludesPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "includes",
        type: IncludesPipe,
        pure: true
      });
    }
  }
  return IncludesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let JsTypePipe = /*#__PURE__*/(() => {
  class JsTypePipe {
    transform(value, type) {
      switch (type) {
        case 'date':
          {
            return isDate(value);
          }
        default:
          {
            return isJSType(value, type);
          }
      }
    }
    static {
      this.ɵfac = function JsTypePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || JsTypePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "isJSType",
        type: JsTypePipe,
        pure: true
      });
    }
  }
  return JsTypePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MapPipe = /*#__PURE__*/(() => {
  class MapPipe {
    transform(value, mapHandler, ...args) {
      return Boolean(mapHandler) ? mapHandler(value, ...args) : value;
    }
    static {
      this.ɵfac = function MapPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MapPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "map",
        type: MapPipe,
        pure: true
      });
    }
  }
  return MapPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotDefinedPipe = /*#__PURE__*/(() => {
  class NotDefinedPipe {
    transform(value) {
      return isNullish(value);
    }
    static {
      this.ɵfac = function NotDefinedPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotDefinedPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "notDefined",
        type: NotDefinedPipe,
        pure: true
      });
    }
  }
  return NotDefinedPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotEqualPipe = /*#__PURE__*/(() => {
  class NotEqualPipe {
    transform(value, compareValue) {
      return value !== compareValue;
    }
    static {
      this.ɵfac = function NotEqualPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotEqualPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "notEqual",
        type: NotEqualPipe,
        pure: true
      });
    }
  }
  return NotEqualPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotExistPipe = /*#__PURE__*/(() => {
  class NotExistPipe extends ExistPipe {
    transform(value, array = []) {
      return !super.transform(value, array);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵNotExistPipe_BaseFactory;
        return function NotExistPipe_Factory(__ngFactoryType__) {
          return (ɵNotExistPipe_BaseFactory || (ɵNotExistPipe_BaseFactory = i0.ɵɵgetInheritedFactory(NotExistPipe)))(__ngFactoryType__ || NotExistPipe);
        };
      })();
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "notExist",
        type: NotExistPipe,
        pure: true
      });
    }
  }
  return NotExistPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NumberTransformPipe = /*#__PURE__*/(() => {
  class NumberTransformPipe {
    transform(value) {
      if (!value) return null;
      value = Number(value);
      switch (true) {
        case value < 1000:
          {
            return value;
          }
        case value < 1e6:
          {
            const result = value / 1e3;
            return this.dropZero(result.toFixed(1)) + 'K';
          }
        case value < 1e9:
          {
            const result = value / 1e6;
            return this.dropZero(result.toFixed(1)) + 'M';
          }
        default:
          {
            const result = value / 1e9;
            return this.dropZero(result.toFixed(1)) + 'B';
          }
      }
    }
    dropZero(value) {
      const [integer, float = '0'] = value.split('.');
      const result = `${integer}${float === '0' ? '' : '.' + float}`;
      return result;
    }
    static {
      this.ɵfac = function NumberTransformPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NumberTransformPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "numberTransform",
        type: NumberTransformPipe,
        pure: true
      });
    }
  }
  return NumberTransformPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PickPipe = /*#__PURE__*/(() => {
  class PickPipe {
    transform(value, keys) {
      return keys.reduce((accum, key) => {
        accum[key] = value[key];
        return accum;
        // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter, @typescript-eslint/consistent-type-assertions
      }, {});
    }
    static {
      this.ɵfac = function PickPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PickPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pick",
        type: PickPipe,
        pure: true
      });
    }
  }
  return PickPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PickMapPipe = /*#__PURE__*/(() => {
  class PickMapPipe {
    transform(items, pickedProp) {
      if (Array.isArray(items)) {
        return items.map(item => item[pickedProp]);
      }
      return [];
    }
    static {
      this.ɵfac = function PickMapPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PickMapPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pickMap",
        type: PickMapPipe,
        pure: true
      });
    }
  }
  return PickMapPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PluckPipe = /*#__PURE__*/(() => {
  class PluckPipe {
    transform(value, key) {
      return Boolean(value) ? value[key] : null;
    }
    static {
      this.ɵfac = function PluckPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PluckPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "pluck",
        type: PluckPipe,
        pure: true
      });
    }
  }
  return PluckPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RangePipe = /*#__PURE__*/(() => {
  class RangePipe {
    transform(count, start = 0, value) {
      return {
        *[Symbol.iterator]() {
          for (let i = start; i < count + start; i++) {
            yield value ? value(i) : i;
          }
        }
      };
    }
    static {
      this.ɵfac = function RangePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RangePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "range",
        type: RangePipe,
        pure: true
      });
    }
  }
  return RangePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReplacePipe = /*#__PURE__*/(() => {
  class ReplacePipe {
    transform(value, regExp, replacement = '') {
      if (typeof regExp === 'string') {
        regExp = new RegExp(regExp, 'gi');
      }
      return value.replace(regExp, replacement);
    }
    static {
      this.ɵfac = function ReplacePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ReplacePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "replace",
        type: ReplacePipe,
        pure: true
      });
    }
  }
  return ReplacePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SanitizerPipe = /*#__PURE__*/(() => {
  class SanitizerPipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    transform(value, type) {
      if (!value) return null;
      switch (type) {
        case 'html':
          {
            return this.sanitizer.bypassSecurityTrustHtml(value);
          }
        case 'resource-url':
          {
            return this.sanitizer.bypassSecurityTrustResourceUrl(value);
          }
        case 'script':
          {
            return this.sanitizer.bypassSecurityTrustScript(value);
          }
        case 'style':
          {
            return this.sanitizer.bypassSecurityTrustStyle(value);
          }
        case 'url':
          {
            return this.sanitizer.bypassSecurityTrustUrl(value);
          }
        default:
          {
            throw new Error('Invalid sanitize type');
          }
      }
    }
    static {
      this.ɵfac = function SanitizerPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SanitizerPipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "sanitize",
        type: SanitizerPipe,
        pure: true
      });
    }
  }
  return SanitizerPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SplitStringPipe = /*#__PURE__*/(() => {
  class SplitStringPipe {
    transform(value, separator = '') {
      return String(value).split(separator);
    }
    static {
      this.ɵfac = function SplitStringPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SplitStringPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "splitString",
        type: SplitStringPipe,
        pure: true
      });
    }
  }
  return SplitStringPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StringLimitPipe = /*#__PURE__*/(() => {
  class StringLimitPipe {
    transform(value, length, suffix = '...') {
      return value?.length > length ? value.slice(0, length) + suffix : value;
    }
    static {
      this.ɵfac = function StringLimitPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StringLimitPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "stringLimit",
        type: StringLimitPipe,
        pure: true
      });
    }
  }
  return StringLimitPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SymbolLimit = /*#__PURE__*/(() => {
  class SymbolLimit {
    transform(value, limit, endsWith = '...') {
      const stringValue = String(value);
      if (stringValue.length > limit) {
        return stringValue.slice(0, limit).concat(endsWith);
      }
      return stringValue;
    }
    static {
      this.ɵfac = function SymbolLimit_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SymbolLimit)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "symbollimit",
        type: SymbolLimit,
        pure: true
      });
    }
  }
  return SymbolLimit;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TagReplacerPipe = /*#__PURE__*/(() => {
  class TagReplacerPipe {
    transform(value, tagsObj) {
      return replaceTags(value, tagsObj);
    }
    static {
      this.ɵfac = function TagReplacerPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TagReplacerPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "tagReplacer",
        type: TagReplacerPipe,
        pure: true
      });
    }
  }
  return TagReplacerPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TypeParser = /*#__PURE__*/(() => {
  class TypeParser {
    transform(value, type) {
      switch (type) {
        case 'string':
          return String(value);
        case 'number':
          return Number(value);
        case 'boolean':
          return Boolean(value);
        case 'date':
          return new Date(value);
        case 'array':
          return Array.from(value);
        case 'json':
          return JSON.parse(value);
        case 'stringify':
          return JSON.stringify(value);
        default:
          return value;
      }
    }
    static {
      this.ɵfac = function TypeParser_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TypeParser)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "toType",
        type: TypeParser,
        pure: true
      });
    }
  }
  return TypeParser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const imports = [SplitStringPipe, SanitizerPipe, DefinedPipe, ConditionPipe, DefaultValuePipe, EqualPipe, NotEqualPipe, IncludesPipe, PickPipe, SymbolLimit, MapPipe, TypeParser, JsTypePipe, AffixPipe, ExcludePropertiesPipe, FilterPipe, PluckPipe, PickMapPipe, EndsWithPipe, NotDefinedPipe, ExistPipe, NotExistPipe, NumberTransformPipe, TagReplacerPipe, StringLimitPipe, CurrencySymbolPipe, ReplacePipe, RangePipe];
let UtilsPipesModule = /*#__PURE__*/(() => {
  class UtilsPipesModule {
    static {
      this.ɵfac = function UtilsPipesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UtilsPipesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UtilsPipesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return UtilsPipesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WrapToArrayPipe = /*#__PURE__*/(() => {
  class WrapToArrayPipe {
    transform(value) {
      return wrapToArray(value);
    }
    static {
      this.ɵfac = function WrapToArrayPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WrapToArrayPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "wrapToArray",
        type: WrapToArrayPipe,
        pure: true
      });
    }
  }
  return WrapToArrayPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AffixPipe, ConditionPipe, CurrencySymbolPipe, DefaultValuePipe, DefinedPipe, EndsWithPipe, EqualPipe, ExcludePropertiesPipe, ExistPipe, FilterPipe, IncludesPipe, JsTypePipe, MapPipe, NotDefinedPipe, NotEqualPipe, NotExistPipe, NumberTransformPipe, PickMapPipe, PickPipe, PluckPipe, RangePipe, ReplacePipe, SanitizerPipe, SplitStringPipe, StringLimitPipe, SymbolLimit, TagReplacerPipe, TypeParser, UtilsPipesModule, WrapToArrayPipe };
